import React, { useEffect } from 'react';
import { FB_PIXEL_ID } from '../constants/tracking';
export function MetaPixel() {
  useEffect(() => {
    // Only run on client side
    if (typeof window !== 'undefined') {
      import('meta-pixel').then(module => {
        const {
          default: pixel
        } = module;
        // Initialize Facebook Pixel
        pixel.init('1485525869566246');
        // Track PageView
        pixel.pageView();
        // Make pixel available globally for custom events
        window.fbq = pixel.event;
      });
    }
    return () => {
      // Clean up if needed
    };
  }, []);
  return <>
      {/* Noscript fallback for users with JavaScript disabled */}
      <noscript data-id="element-258">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1485525869566246&ev=PageView&noscript=1" alt="" data-id="element-259" />
      </noscript>
    </>;
}